module.exports = __webpack_public_path__ + "assets/img/Print.7612635e.png";